export const evolutionFilterTree = [
  {
    value: "Geral",
    label: "Geral",
    className:"indicator --general",
    showCheckbox: false,
    children: [
      { 
        value: "Químico", 
        label: "Químico",
        showCheckbox: false,
        className:"indicator --chemical",
        children: [
          {
            value: "pH",
            label: "pH",
            className:"indicator --ph",
            showCheckbox: false,
          },
          {
            value: "m (%)",
            label: "m (%)",
            className:"indicator --m",
            showCheckbox: false,
          },
          {
            value: "Zn (mg/dm3)",
            label: "Zn (mg/dm3)",
            className:"indicator --Zn",
            showCheckbox: false,
          },
          {
            value: "V (%)",
            label: "V (%)",
            className:"indicator --V",
            showCheckbox: false,
          },
          {
            value: "S (mg/dm3)",
            label: "S (mg/dm3)",
            className:"indicator --S",
            showCheckbox: false,
          },
          {
            value: "P (mg/dm3)",
            label: "P (mg/dm3)",
            className:"indicator --P",
            showCheckbox: false,
          },
          {
            value: "Mn (mg/dm3)",
            label: "Mn (mg/dm3)",
            className:"indicator --Mn",
            showCheckbox: false,
          },
          {
            value: "MO (dag/kg ou %)",
            label: "MO (dag/kg ou %)",
            className:"indicator --MO",
            showCheckbox: false,
          },
  
          {
            value: "Cu (mg/dm3)",
            label: "Cu (mg/dm3)",
            className:"indicator --Cu",
            showCheckbox: false,
          },
          {
            value: "B (mg/dm3)",
            label: "B (mg/dm3)",
            className:"indicator --B",
            showCheckbox: false,
          }
        ] 
      },
      {
        value: "Biológico",
        label: "Biológico",
        showCheckbox: false,
        className:"indicator --biologic",
        children: [
          {
            value: "IQS_tax",
            label: "IQS_tax",
            className:"indicator --IQS_tax",
            showCheckbox: false,
          },
          {
            value: "IQS_Ec",
            label: "IQS_Ec",
            className:"indicator --IQS_Ec",
            showCheckbox: false,
          },
          {
            value: "GF_total",
            label: "GF_total",
            className:"indicator --GF_total",
            showCheckbox: false,
          }
        ],
      }
    ],
  }
]
